import { useEffect, useState } from 'react';
import { fetchAppConfig as fetchAppConfigService } from '../services/appConfigService';

interface AppConfig {
  googleMapsApiKey?: string;
  googleMapsApiMatrixKey?: string;
  [key: string]: unknown;
}

export const useAppConfig = () => {
  const [appConfig, setAppConfig] = useState<AppConfig | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      setLoading(true);
      try {
        const config = await fetchAppConfigService();
        if (alive) setAppConfig(config || null);
      } catch (error) {
        console.error('Failed to load app config:', error);
        if (alive) setAppConfig(null);
      } finally {
        if (alive) setLoading(false);
      }
    };
    load();
    return () => {
      alive = false;
    };
  }, []);

  const envGoogleMapsKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '';
  const googleMapsApiKey =
    appConfig?.googleMapsApiKey ||
    appConfig?.googleMapsApiMatrixKey ||
    envGoogleMapsKey ||
    '';

  return { appConfig, googleMapsApiKey, loading };
};
